import React from 'react';

const HealthFitnessDisclaimer = () => {
  const effectiveDate = '23 September 2025';
  return (
    <main className="bg-white">
      <section className="py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl md:text-5xl font-light text-charcoal-900 mb-6">
            Alera – Health & Fitness Disclaimer
          </h1>
          <p className="text-charcoal-600 mb-2">Effective Date: {effectiveDate}</p>

          <div className="prose prose-lg max-w-none text-charcoal-700 mt-8 space-y-6">
            <p>
              The information on Alera is provided for general educational and informational purposes only.
            </p>
            <p>
              Alera is not a medical or healthcare provider, and nothing on this website should be taken as medical advice, diagnosis, or treatment.
            </p>
            <p>
              I am a Certified Personal Trainer, hold a Master’s Certificate in Fitness Programming for Females, and am a Certified Nutritionist. The recipes, fitness programs, and wellness resources shared on Alera are created using my professional training, certifications, and personal experience. However, they are general in nature and not tailored to your individual medical needs or conditions.
            </p>
            <p>
              Always consult with a qualified physician or healthcare provider before making changes to your diet, exercise routine, or managing allergies, eczema, asthma, or other health conditions.
            </p>
            <p>
              Participation in workouts, fitness programs, or following recipes from Alera is voluntary and at your own risk.
            </p>
            <p>
              Alera and its creator(s) are not responsible for any injury, illness, allergic reaction, or other issues that may arise from the use of this website or its resources.
            </p>
            <p>
              By using Alera, you acknowledge and agree to these terms.
            </p>
          </div>
        </div>
      </section>
    </main>
  );
};

export default HealthFitnessDisclaimer;
